import React from 'react';
import { MenuItem, MenuSeparator } from '../components/Menu';
import templateIcon from '../icons/template.svg';
import TemplateRow from './TemplateRow';
import styles from './TemplatesMenuItem.module.scss';
import useTemplatesList from './useTemplatesList';

export const TemplatesMenuItemSubmenu = () => {
  const templatesList = useTemplatesList({ totalLimit: 10, sectionLimit: 5 });

  return (
    <div className={styles.subMenu}>
      {templatesList.map((section) => (
        <React.Fragment key={section.title}>
          <div className={styles.header}>{section.title}</div>
          {section.templates.map((template) => (
            <TemplateRow
              key={'id' in template ? template.id : template.title}
              template={template}
              padding="small"
              showHoverCard
            />
          ))}
          <MenuSeparator />
        </React.Fragment>
      ))}
      <MenuItem to="/templates">View all templates</MenuItem>
    </div>
  );
};

const TemplatesMenuItem = () => (
  <MenuItem icon={templateIcon} subMenuItems={<TemplatesMenuItemSubmenu />}>
    Templates
  </MenuItem>
);

export default TemplatesMenuItem;
